import styled from 'styled-components';
import { UserOutlined, BookOutlined } from '@ant-design/icons';
import { media } from '../../../../../styles/themes/constants';

export const NavigationContainer = styled.div`
  position: relative;
  z-index: 1000;
  background: rgba(255, 255, 255, 0.95);
  border: 1px solid rgba(255, 255, 255, 0.8);
  border-radius: 8px;
  backdrop-filter: blur(10px);
  padding: 12px 0;
  margin: 8px 6px;

  @media (max-width: 767px) {
    margin: 8px 2px;
    padding: 8px 0;
  }
  
  @media (min-width: 768px) and (max-width: 1199px) {
    margin: 8px 8px;
  }
  
  @media (min-width: 1200px) {
    margin: 8px 18px;
  }
  
  @media (min-width: 1400px) {
    margin: 8px 30px;
  }
`;

export const NavigationWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 16px; /* Увеличиваем расстояние между кнопками */
  padding: 0 20px; /* Увеличиваем боковые отступы */
  justify-content: flex-start;
  width: 100%;
  max-width: none;
`;

export const LogoSection = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  min-width: 200px;
`;

export const LogoIcon = styled(BookOutlined)`
  font-size: 32px;
  color: #ffffff;
  background: linear-gradient(45deg, #60a5fa, #a78bfa);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
`;

export const LogoText = styled.h1`
  margin: 0;
  font-size: 24px;
  font-weight: 700;
  color: #ffffff;
  background: linear-gradient(45deg, #ffffff, #e2e8f0);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  letter-spacing: -0.025em;

  @media only screen and ${media.sm} {
    font-size: 20px;
  }
`;

export const MenuSection = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  justify-content: flex-start;
  flex-wrap: wrap; /* Позволяем переносить элементы на новую строку */

  @media (max-width: 767px) {
    gap: 4px; /* Меньше расстояние между кнопками */
    overflow-x: auto; /* Горизонтальная прокрутка если не помещается */
    flex-wrap: nowrap; /* Не переносим на мобильных */
    
    /* Скрываем скроллбар */
    &::-webkit-scrollbar {
      display: none;
    }
    -ms-overflow-style: none;
    scrollbar-width: none;
  }
`;

export const MenuItem = styled.div<{ $active: boolean; $hovered: boolean }>`
  display: flex;
  align-items: center;
  padding: 8px 12px; /* Уменьшаем отступы кнопок */
  border-radius: 6px; /* Уменьшаем радиус */
  cursor: pointer;
  transition: all 0.2s ease;
  font-weight: 500;
  font-size: 12px; /* Уменьшаем размер шрифта */
  color: ${props => props.$active ? '#ffffff' : '#6c757d'};
  background: ${props => {
    if (props.$active) return '#007bff';
    if (props.$hovered) return '#f8f9fa';
    return '#ffffff';
  }};
  border: 1px solid ${props => {
    if (props.$active) return '#007bff';
    return '#dee2e6';
  }};
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.08); /* Уменьшаем тень */
  white-space: nowrap; /* Не переносим текст */
  flex-shrink: 0; /* Не сжимаем кнопки */

  &:hover {
    background: ${props => props.$active ? '#0056b3' : '#f8f9fa'};
    border-color: ${props => props.$active ? '#0056b3' : '#adb5bd'};
  }

  .anticon {
    font-size: 14px; /* Уменьшаем размер иконок */
    margin-right: 6px; /* Уменьшаем отступ */
  }

  @media (max-width: 767px) {
    padding: 6px 8px; /* Еще меньше отступы на мобильных */
    font-size: 11px; /* Меньше шрифт */
    
    .anticon {
      font-size: 12px; /* Меньше иконки */
      margin-right: 4px; /* Меньше отступ */
    }
  }
`;

export const UserSection = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  min-width: 200px;
  justify-content: flex-end;
`;

export const UserAvatar = styled(UserOutlined)`
  font-size: 20px;
  color: #ffffff;
  background: rgba(255, 255, 255, 0.2);
  padding: 12px;
  border-radius: 50%;
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.3);
`;

export const UserInfo = styled.div`
  display: flex;
  flex-direction: column;

  @media only screen and ${media.sm} {
    display: none;
  }
`;

export const UserName = styled.span`
  font-weight: 600;
  font-size: 14px;
  color: #ffffff;
  line-height: 1.2;
`;

// Mobile Menu (for responsive design)
export const MobileMenuButton = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.9);
  cursor: pointer;
  transition: all 0.3s ease;
  border: 1px solid rgba(0, 123, 255, 0.3);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);

  &:hover {
    background: rgba(255, 255, 255, 1);
    border-color: rgba(0, 123, 255, 0.5);
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
  }
`;

export const MobileMenu = styled.div<{ $isOpen: boolean }>`
  display: ${props => props.$isOpen ? 'flex' : 'none'};
  position: absolute;
  top: 100%;
  left: 8px;
  right: 8px;
  background: rgba(255, 255, 255, 0.98);
  backdrop-filter: blur(20px);
  border: 1px solid rgba(0, 123, 255, 0.2);
  border-radius: 8px;
  flex-direction: column;
  padding: 12px;
  gap: 4px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.15);
  z-index: 9999; /* Максимальный z-index для отображения поверх всех элементов */
  margin-top: 4px;

  @media (min-width: 768px) {
    display: none !important;
  }
`;

export const MobileMenuItem = styled.div<{ $active: boolean }>`
  display: flex;
  align-items: center;
  padding: 12px 16px;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.2s ease;
  font-weight: 500;
  font-size: 14px;
  color: ${props => props.$active ? '#ffffff' : '#495057'};
  background: ${props => props.$active ? '#007bff' : 'transparent'};
  border: 1px solid ${props => props.$active ? '#007bff' : 'transparent'};

  &:hover {
    background: ${props => props.$active ? '#0056b3' : '#f8f9fa'};
    border-color: ${props => props.$active ? '#0056b3' : '#dee2e6'};
  }

  .anticon {
    font-size: 16px;
    margin-right: 8px;
    color: ${props => props.$active ? '#ffffff' : '#6c757d'};
  }
`;

// Mobile right section for Language and Auth buttons
export const MobileRightSection = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

interface MobileNavAuthButtonProps {
  $isAuthenticated?: boolean;
}

export const MobileNavAuthButton = styled.button<MobileNavAuthButtonProps>`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 6px 12px;
  border-radius: 6px;
  border: 1px solid ${props => props.$isAuthenticated ? '#ff4d4f' : '#007bff'};
  background: ${props => props.$isAuthenticated ? 'rgba(255, 77, 79, 0.1)' : '#007bff'};
  color: ${props => props.$isAuthenticated ? '#ff4d4f' : '#ffffff'};
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  white-space: nowrap;
  
  &:hover {
    opacity: 0.9;
    background: ${props => props.$isAuthenticated ? 'rgba(255, 77, 79, 0.2)' : '#0056b3'};
  }

  .anticon {
    font-size: 14px;
  }
`;
